<template>
  <v-toolbar class="sticky-toolbar" flat>
    <div v-if="tabs.length" class="tabs-container">
      <v-tabs
        v-model="internalTab"
        color="warning"
        density="comfortable"
        show-arrows
        hide-slider
        class="admin-tabs"
      >
        <v-tab
          v-for="item in tabs"
          :key="item.value"
          :value="item.value"
          class="custom-tab"
        >
          <v-icon
            v-if="item.icon"
            :icon="item.icon"
            size="17"
            class="tab-icon"
          />

          <span>{{ item.label }}</span>

          <span v-if="item.count !== undefined" class="tab-count">
            {{ item.count }}
          </span>
        </v-tab>
      </v-tabs>
    </div>
  </v-toolbar>
</template>

<script>
export default {
  name: "RbDialogToolbar",

  props: {
    title: {
      type: String,
      required: true,
    },

    tabs: {
      type: Array,
      default: () => [],
    },

    modelValue: {
      type: [String, Number],
      default: null,
    },
  },

  computed: {
    internalTab: {
      get() {
        return this.modelValue;
      },

      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
};
</script>

<style scoped>
.sticky-toolbar {
  position: sticky;
  top: 0;
  z-index: 1000;
  width: 100%;
  height: 56px !important;
  min-height: 56px !important;
  background: #46474f !important;
  border-bottom: 1px solid #2b303a;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
  padding: 6px 0px;
}

/* Tabs container */
.tabs-container {
  width: 100%;
  height: 56px;
  padding: 6px 0px;
  display: flex;
  align-items: center;
}

.admin-tabs {
  width: 100%;
  height: 56px;
}

/* Tab */

.custom-tab {
  position: relative;
  min-width: auto !important;
  height: 56px !important;
  margin: 0 4px 0 0;
  padding: 0 17px !important;
  border-radius: 0;
  font-size: 13px !important;
  font-weight: 500 !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  color: #ffffff !important;
  opacity: 0.75 !important;
  transition: opacity 0.2s ease, background-color 0.2s ease;
}

/* Hover */

.custom-tab:hover {
  opacity: 1 !important;
  background: rgba(255, 255, 255, 0.06);
}

/* Active */

.custom-tab.v-tab--selected {
  color: #ffffff !important;
  opacity: 1 !important;
  font-weight: 600 !important;
  background: rgba(255, 255, 255, 0.08) !important;
}

/* Active indicator */

.custom-tab.v-tab--selected::after {
  content: "";
  position: absolute;
  left: 12px;
  right: 12px;
  bottom: 0;
  height: 3px;
  background: rgb(var(--v-theme-warning));
  border-radius: 3px 3px 0 0;
}

/* Icon */

.tab-icon {
  margin-right: 7px;
  color: #ffffff !important;
}

/* Count */

.tab-count {
  min-width: 20px;
  height: 20px;
  margin-left: 8px;
  padding: 0 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  color: #ffffff;
  font-size: 11px;
  font-weight: 600;
}

.custom-tab.v-tab--selected .tab-count {
  background: rgba(var(--v-theme-warning), 0.2);
  color: rgb(var(--v-theme-warning));
}

/* Vuetify */

:deep(.v-toolbar__content) {
  height: 56px !important;
  padding: 0 !important;
}

:deep(.v-tab__slider) {
  display: none !important;
}

:deep(.v-tabs__content) {
  height: 56px;
}
</style>